type ImageSignature = {
  mimeType: 'image/jpeg' | 'image/png' | 'image/webp' | 'image/gif';
  extension: '.jpg' | '.png' | '.webp' | '.gif';
};

function detectImageSignature(bytes: Uint8Array): ImageSignature | null {
  if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
    return { mimeType: 'image/jpeg', extension: '.jpg' };
  }
  if (
    bytes.length >= 8
    && bytes[0] === 0x89
    && bytes[1] === 0x50
    && bytes[2] === 0x4e
    && bytes[3] === 0x47
    && bytes[4] === 0x0d
    && bytes[5] === 0x0a
    && bytes[6] === 0x1a
    && bytes[7] === 0x0a
  ) {
    return { mimeType: 'image/png', extension: '.png' };
  }
  if (
    bytes.length >= 12
    && bytes[0] === 0x52
    && bytes[1] === 0x49
    && bytes[2] === 0x46
    && bytes[3] === 0x46
    && bytes[8] === 0x57
    && bytes[9] === 0x45
    && bytes[10] === 0x42
    && bytes[11] === 0x50
  ) {
    return { mimeType: 'image/webp', extension: '.webp' };
  }
  if (
    bytes.length >= 6
    && bytes[0] === 0x47
    && bytes[1] === 0x49
    && bytes[2] === 0x46
    && bytes[3] === 0x38
    && (bytes[4] === 0x37 || bytes[4] === 0x39)
    && bytes[5] === 0x61
  ) {
    return { mimeType: 'image/gif', extension: '.gif' };
  }
  return null;
}

function replaceFileExtension(filename: string, extension: ImageSignature['extension']): string {
  const base = filename.replace(/\.[^.]+$/, '') || 'upload';
  return `${base}${extension}`;
}

/**
 * Browser File.type is derived from the filename on some platforms. Sniff the
 * safe raster signatures that Canvas accepts so presign, COS metadata and the
 * persisted asset contract all describe the bytes that are actually uploaded.
 */
export async function normalizeImageFileSignature(file: File): Promise<File> {
  const header = new Uint8Array(await file.slice(0, 16).arrayBuffer());
  const signature = detectImageSignature(header);
  if (!signature) return file;

  const normalizedName = replaceFileExtension(file.name, signature.extension);
  if (file.type === signature.mimeType && file.name === normalizedName) return file;

  return new File([file], normalizedName, {
    type: signature.mimeType,
    lastModified: file.lastModified,
  });
}
